export const EMP_LIST="EMP_LIST";
export const SUP_LIST="SUP_LIST";
export const EMP_LIST_BYPROJECTID="EMP_LIST_BYPROJECTID";
export const BULK_APPROVE_TASK="BULK_APPROVE_TASK";